export default "__VITE_ASSET__DPYN4bCd__"